import React, { FC } from 'react';
import { useTheme } from 'styled-components';

interface IDot {
  cx: number;
  cy: number;
  value: number;
}

const Dot: FC<IDot> = ({ cx, cy, value }) => {
  const theme = useTheme();

  const COLOR =
    value <= 30
      ? theme.colors.accent.red[100]
      : value > 30 && value <= 70
        ? theme.colors.accent.blue[100]
        : theme.colors.accent.green[100];

  return (
    <g>
      <circle cx={cx} cy={cy} width={48} height={48} r="24" fill={COLOR} />
      <text
        x={cx}
        y={cy + 8}
        fill={theme.colors.neutral.primary[0]}
        fontSize="24"
        fontWeight="700"
        textAnchor="middle"
      >
        {value}
      </text>
    </g>
  );
};

export default Dot;
